<template>
  <div class="mode-container" :style="containerStyle">
    <div>
      <div class="slider" :style="sliderStyle"></div>
      <div class="mode-option" v-for="mode in modes" :key="mode.value"
        :class="{ active: value === mode.value }" @click="$emit('input', mode.value)">
        {{ mode.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { THEME_MODE } from '@/layout/layout/setup/theme-system/config'
export default {
  props: {
    // 当前选中的主题模式值
    value: {
      type: String,
      default: 'light'
    },
    // 自定义样式
    containerStyle: {
      type: Object,
      default: () => ({ backgroundColor: '#F1F2F9' })
    }
  },
  data() {
    return {
      modes: THEME_MODE
    }
  },
  computed: {
    // 滑块位置样式，通过 transform 实现位移动画
    sliderStyle() {
      const index = this.modes.findIndex(item => item.value === this.value)
      return {
        transform: `translateX(${index * 100}%)`,
        width: `${100 / this.modes.length}%`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mode-container {
  display: flex;
  border-radius: 22px;
  position: relative;
  padding: 0 4px;
  &>div {
    display: flex;
    flex: 1;
    position: relative;
    padding: 4px 0;
  }
}

.mode-option {
  height: 32px;
  align-items: center;
  display: flex;
  justify-content: center;
  flex: 1;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 15px;
  color: #888EA6;
  position: relative;
  z-index: 1;
}

.mode-option.active {
  color: #000;
  font-weight: 500;
}

.slider {
  position: absolute;
  top: 4px;
  left: 0;
  height: calc(100% - 8px);
  background-color: white;
  border-radius: 55px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(0);
  will-change: transform;
  z-index: 0;
  box-shadow: 0px 0px 4px 0px rgba(214, 216, 229, 1);
}
</style>



// WEBPACK FOOTER //
// src/layout/components/appearance-mode.vue